/**
 * 2014-2022 Blixsoft Technologies.
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Open Software License (OSL 3.0)
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/OSL-3.0
 * If you did not receive a copy of the license and are unable to obtain
 * it through the world-wide-web, please send an email
 * to license@blixsoft.com so we can send you a copy immediately.
 *
 * @author    Blixsoft Technologies <support@blixsoft.com>
 * @copyright 2014-2022 Blixsoft Technologies
 * @license   https://opensource.org/licenses/OSL-3.0 Open Software License (OSL 3.0)
 */

const defines = {
  data: () => ({
    NAME: 'PACH Supervisión',
    VERSION: '1.0.4',

    API: 'https://api.pach.com.mx/supervision/ajax/',
    STATIC: 'https://static.pach.com.mx/',
    APP: 'https://supervision.pach.com.mx/',
    DOCS: 'https://docs.pach.com.mx/',

    IMG: 'img',
    IMG_AVATAR: '/avatars/',
    IMG_BRAND: '/brand/',
    IMG_ICONS: '/icons/',
    IMG_CONTENT: '/content/',

    STATIC_IMG_AVATAR: '',

    APP_IMG_BRAND: '',
    APP_IMG_ICONS: '',
    APP_IMG_CONTENT: '',

    YEAR: new Date().getFullYear()
  }),
  created () {
    this.STATIC_IMG_AVATAR = this.STATIC + this.IMG + this.IMG_AVATAR

    this.APP_IMG_BRAND = this.IMG + this.IMG_BRAND
    this.APP_IMG_ICONS = this.IMG + this.IMG_ICONS
    this.APP_IMG_CONTENT = this.IMG + this.IMG_CONTENT
  }
}

const layout = {
  data: () => ({ })
}

const theme = {
  data: () => ({ }),
  methods: {
    toggleTheme () {
      const body = document.querySelector('body')
      const auth = JSON.parse(localStorage.getItem('supervision'))

      this.$vuetify.theme.dark = !this.$vuetify.theme.dark

      const supervision = {
        theme: {
          dark: this.$vuetify.theme.dark,
          color: auth.theme.color,
          accent: auth.theme.accent
        },
        layout: {
          mini: auth.layout.mini,
          expandOnHover: auth.layout.expandOnHover
        },
        session: auth.session
      }

      localStorage.setItem('supervision', JSON.stringify(supervision))

      if (this.$vuetify.theme.dark) {
        body.style.backgroundColor = '#121212'
      } else {
        body.style.backgroundColor = '#FFFFFF'
      }
    }
  },
  mounted () {
    const auth = JSON.parse(localStorage.getItem('supervision'))

    this.$vuetify.theme.dark = auth.theme.dark
    // this.$vuetify.theme.themes.light.primary = '#4caf50'
  }
}

const passwds = {
  data: () => ({
    chars: '123456789ABCDEFGHI0JKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-*[]{}¿?%&()¡!$#',
    passwordLenght: 10,
    passwd: ''
  }),
  methods: {
    generatePasswd () {
      this.passwd = ''

      for (let i = 1; i <= this.passwordLenght; i++) {
        const randNum = Math.floor(Math.random() * this.chars.length)
        this.passwd += this.chars.substring(randNum, randNum + 1)
      }

      return this.passwd
    }
  }
}

const pin = {
  data: () => ({
    nums: '0123456789012345678901234567890123456789',
    pinLenght: 4,
    pin: ''
  }),
  methods: {
    generatePIN () {
      this.pin = ''

      for (let i = 1; i <= this.pinLenght; i++) {
        const randNum = Math.floor(Math.random() * this.nums.length)
        this.pin += this.nums.substring(randNum, randNum + 1)
      }

      return this.pin
    }
  }
}

const session = {
  data: () => ({
    auth: {
      userID: null,
      role: null,
      color: null,
      avatar: null,
      avatarText: null,
      name: null,
      email: null
    }
  }),
  methods: {
    sessionSync () {
      const auth = JSON.parse(localStorage.getItem('supervision'))
      const sessionDecrypt = JSON.parse(atob(auth.session))

      if (sessionDecrypt) {
        this.auth.userID = sessionDecrypt.userID
        this.auth.role = sessionDecrypt.role
        this.auth.color = sessionDecrypt.color
        this.auth.avatar = (sessionDecrypt.avatarID === '') ? null : sessionDecrypt.avatarID
        this.auth.avatarText = sessionDecrypt.avatarText
        this.auth.name = sessionDecrypt.name
        this.auth.email = sessionDecrypt.email
      }
    }
  },
  watch: { },
  computed: { },
  mounted () {
    this.sessionSync()
  },
  created () { }
}

const auth = {
  data: () => ({ }),
  methods: { },
  watch: { },
  computed: { },
  mounted () { },
  created () {
    const auth = localStorage.getItem('supervision')

    if (!auth) {
      this.$router.push({ name: 'LoginView' }).catch(() => {})
    }
  }
}

export { defines, layout, auth, session, theme, passwds, pin }
